import React from "react";

/**
 * NEURACOM by TelcaVoIP — official logo (PNG with transparent background).
 * Source asset: /brand/neuracom-logo.png (provided by client).
 * Works on both light and dark backgrounds.
 */
export function Logo({ size = "md", showByline = true, className = "", inverted = false }) {
  const sizes = {
    sm: { h: 26, byline: "text-[9px]", gap: "gap-2" },
    md: { h: 34, byline: "text-[10px]", gap: "gap-2.5" },
    lg: { h: 48, byline: "text-xs", gap: "gap-3" },
    xl: { h: 72, byline: "text-sm", gap: "gap-4" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center ${s.gap} ${className}`} data-testid="neuracom-logo">
      <img
        src={inverted ? "/brand/neuracom-logo-white.png" : "/brand/neuracom-logo.png"}
        alt="NEURACOM"
        height={s.h}
        style={{ height: s.h, width: "auto", display: "block" }}
        draggable={false}
      />
      {showByline && (
        <span
          className={`hidden sm:inline ${s.byline} font-semibold uppercase tracking-[0.22em] ${
            inverted ? "text-[#A6CE00]" : "text-[#7AAA20]"
          }`}
        >
          by TelcaVoIP
        </span>
      )}
    </div>
  );
}
